<p-card>
  <form [formGroup]="typePrestationForm" (ngSubmit)="addTypePrestation()">
    <div class="field grid">
      <label for="codeHecate" class="col-12 mb-2 md:col-3">{{'referentiels.list.typePrestationProperties.codeHecate.header' | transloco }}</label>
      <div class="col-12 md:col-3 md:mb-1">
        <input pInputText formControlName="codeHecate" class="flex-auto" />
      </div>
      <label class="col-12 mb-2 md:col-3" for="designation">{{'referentiels.list.typePrestationProperties.designation.header' | transloco }}<span class="required">*</span></label>
      <div class="col-12 md:col-3 md:mb-1">
        <input pInputText formControlName="designation" class="flex-auto" />
        <small class="p-error block" *ngIf="typePrestationForm.get('designation')?.invalid && typePrestationForm.get('designation')?.dirty">{{'referentiels.error.mandatory.typeprestation.designation' | transloco }}</small>
      </div>
    </div>
    <div class="field grid">
      <label class="col-12 mb-2 md:col-3" for="transport">{{'referentiels.list.typePrestationProperties.transport.header' | transloco }}</label>
      <div class="col-12 md:col-3 md:mb-1">
        <p-checkbox formControlName="transport" [binary]="true" />
      </div>
      <label class="col-12 mb-2 md:col-3" for="suffisantPourDemande">{{'referentiels.list.typePrestationProperties.suffisantPourDemande.header' | transloco }}</label>
      <div class="col-12 md:col-3 md:mb-1">
        <p-checkbox formControlName="suffisantPourDemande" [binary]="true" />
      </div>
    </div>
    <div class="field grid">
      <label class="col-12 mb-2 md:col-3" for="afficherSurLaConfirmation">{{'referentiels.list.typePrestationProperties.afficherSurLaConfirmation.header' | transloco }}</label>
      <div class="col-12 md:col-3 md:mb-1">
        <p-checkbox formControlName="afficherSurLaConfirmation" [binary]="true" />
      </div>
      <label class="col-12 mb-2 md:col-3" for="envoiTennaxia">{{'referentiels.list.typePrestationProperties.envoiTennaxia.header' | transloco }}</label>
      <div class="col-12 md:col-3 md:mb-1">
        <p-checkbox formControlName="envoiTennaxia" [binary]="true" />
      </div>
    </div>
    <div class="field grid">
      <label class="col-12 mb-2 md:col-3" for="unite">{{'referentiels.list.typePrestationProperties.unite.header' | transloco }}</label>
      <div class="col-12 md:col-3 md:mb-1">
        <p-dropdown [options]="unites" formControlName="unite" optionLabel="designation" [showClear]="true" placeholder="{{ 'referentiels.list.typePrestationProperties.unite.placeholder' | transloco }}" styleClass="w-full" />
      </div>
    </div>
    <div class="flex justify-content-end gap-2">
      <p-button label="{{ 'button.cancel' | transloco }}" severity="secondary" (onClick)="close(true)" />
      <p-button type="submit" label="{{ 'button.validate' | transloco }}" [disabled]="typePrestationForm.invalid" />
    </div>
  </form>

  <p-toast />
</p-card>
